import cn from 'classnames'
import { Typography } from '@grammarly/badger-ui'
import { LogoLogomarkColorDefaultIcon } from '@grammarly/design-system'

import styles from './helper-message.module.scss'
import { AlreadyHaveAnAccountLink, SignUpButton } from './ctas'
import { getTextColor } from '@components/page-section/theme'
import { Themes } from 'src/contexts/section-theme-context'
import { FormattedMessage, useIntl } from 'react-intl'

const { TXL, TM } = Typography

interface HelperMessageProps {
  ctaScaleUp?: boolean
  hasSeenWall: boolean
  isForPlagiarismPlanPage: boolean
}

export const HelperMessage = (props: HelperMessageProps) => {
  const intl = useIntl()
  const { ctaScaleUp, hasSeenWall, isForPlagiarismPlanPage } = props
  const placement = hasSeenWall ? 'wallSide' : 'initialSide'

  return (
    <div className={cn(styles.helperMessageContainer, getTextColor(Themes.Light))}>
      <div className={styles.topSection}>
        <div className={styles.header}>
          <div className={styles.logoContainer}>
            <LogoLogomarkColorDefaultIcon
              aria-label={intl.formatMessage({
                id: 'logo.grammarly.ariaLabel',
                description: 'Logo - Grammarly - Aria Label',
                defaultMessage: 'Grammarly Logo',
              })}
              style={{ height: '30px', width: '30px' }}
              aria-hidden={true}
            />
          </div>
          <TXL as="h2">
            <strong>
              <FormattedMessage
                id="textChecker.reportFlow.form.helperMessage.heading"
                description="TextChecker - Report Flow - Form - Helper Message - Heading"
                defaultMessage="Let's get started."
              />
            </strong>
          </TXL>
        </div>
        <TM as="div" className={styles.instructions}>
          <p>
            <FormattedMessage
              id="textChecker.reportFlow.form.helperMessage.step1"
              description="TextChecker - Report Flow - Form - Helper Message - Step 1"
              defaultMessage="<strong>Step 1:</strong> Add your text or upload a file."
              values={{
                strong: (chunks) => <strong>{chunks}</strong>,
              }}
            />
          </p>
          <p>
            <FormattedMessage
              id="textChecker.reportFlow.form.helperMessage.step2"
              description="TextChecker - Report Flow - Form - Helper Message - Step 2"
              defaultMessage="<strong>Step 2:</strong> Click to scan for plagiarism."
              values={{
                strong: (chunks) => <strong>{chunks}</strong>,
              }}
            />
          </p>
          <p>
            <FormattedMessage
              id="textChecker.reportFlow.form.helperMessage.step3"
              description="TextChecker - Report Flow - Form - Helper Message - Step 3"
              defaultMessage="<strong>Step 3:</strong> Review the results for instances of potential plagiarism, plus additional writing issues."
              values={{
                strong: (chunks) => <strong>{chunks}</strong>,
              }}
            />
          </p>
        </TM>
      </div>
      <div className={styles.ctaContainer}>
        <SignUpButton scaleUp={ctaScaleUp} placement={placement} isForPlagiarismPlanPage={isForPlagiarismPlanPage} />
        <AlreadyHaveAnAccountLink placement={placement} />
      </div>
    </div>
  )
}
